module.exports = __webpack_public_path__ + "static/media/Re.5f72fe2d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Re.mp3
// module id = 45
// module chunks = 0